import { render, staticRenderFns } from "./MultiTurbo.vue?vue&type=template&id=620eee3e&scoped=true&"
var script = {}
import style0 from "./MultiTurbo.vue?vue&type=style&index=0&id=620eee3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620eee3e",
  null
  
)

export default component.exports